/* eslint-disable jsx-a11y/no-onchange */
import React from 'react'
import cn from 'classnames'
import s from './Select.module.scss'

interface SelectProps {
    onChange: (e: string) => void
    value: string
    className?: string
    children: React.ReactNode
    [x: string]: any
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
    (
        {
            onChange,
            value,
            className,
            children,
            defaultValue: _ignored,
            ...rest
        },
        ref
    ): React.ReactElement => {
        const rootClassName = cn(
            s.select,
            'appearance-none w-full border-b border-p-7 py-2 px-0 mb-2 focus:shadow-none focus:outline-none focus-visible:border-b focus-visible:shadow-none truncate overflow-hidden pr-8',
            className
        )

        return (
            <select
                className={rootClassName}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                ref={ref}
                {...rest}
            >
                {children}
            </select>
        )
    }
)

Select.displayName = 'Select'

export default Select
